import React from 'react';
import PropTypes from 'prop-types';
import Loader1 from '../../assets/images/loader/pre-loader-01.svg';
import Loader2 from '../../assets/images/loader/pre-loader-02.svg';
import Loader3 from '../../assets/images/loader/pre-loader-03.svg';
import Loader4 from '../../assets/images/loader/pre-loader-04.svg';
import Loader5 from '../../assets/images/loader/pre-loader-05.svg';
import '../../App.css';

const Loader = () => {
  return (
    <div className='re-page-loader' id='pageLoader'>
      <div className='re-page-loader-inner'>
        <div className='fadein-element'>
          <img src={Loader1} alt='Royal Enfield' />
          <img src={Loader2} alt='Royal Enfield' />
          <img src={Loader3} alt='Royal Enfield' />
          <img src={Loader4} alt='Royal Enfield' />
          <img src={Loader5} alt='Royal Enfield' />
        </div>
        <div className='loading-ellipsis'>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
Loader.propTypes = {
  loading: PropTypes.bool,
};
